<template>
    <div id="chargeCodeAccount">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Charge Code Account List</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'chargeCodeAccount'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                          <div class="data-table bg-white overflow-hidden">
                            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                            <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'chargeCodeAccount'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="chargeCodeAccount"
                                    mode="remote"
                                    title="Charge Code Account"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            </section>
                          </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
    name: "ChargeCodeAccountList",
    metaInfo() {
        return {
            title: "Charge Code Account List | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Charge Code',
                field:'charge_code',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Charge Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Charge Name',
                field:'charge_name',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Charge Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Account Type',
                field:'type',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Account Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Facility',
                field:'location',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Contract Type',
                field:'fp_contract_type',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Contract Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Asset Pool',
                field:'asset_pool',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset Pool", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Asset Type',
                field:'asset_type',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Company',
                field:'company',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Company", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'GL Account Code',
                field:'gl_account_code',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "GL Account Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'GL Account Description',
                field:'gl_account_desc',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "GL Account Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_charge_code_account') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.sort = {field:"charge_code",type:"asc"};
    },

    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
              this.$refs.chargeCodeAccount.unselectAllInternal();
            },
        loadList: function() {

            var self = this;

            var filterAll = self.serverParams.columnFilters;
            if ( self.action == "export" ) {
                filterAll = self.removeOptionArr(self.serverParams.columnFilters);
            }
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: filterAll,
                sort: self.serverParams.sort,
                action:self.action
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/charge-code-account/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          // self.loadList();
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'charge-code-account-list')
                }
            });
        },
        exportChargeCodeAccount() {
            var self = this;
            this.action = "export";
            this.loadList();
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/ChargeCodeAccountList.vue